import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TooltipModule } from '@libs/ui-lib';

@Component({
  selector: 'lib-auto-start-prompt',
  standalone: true,
  imports: [TranslateModule, SvgIconComponent, TooltipModule],
  templateUrl: './auto-start-prompt.component.html',
  styleUrl: './auto-start-prompt.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoStartPromptComponent {
  public readonly handleStart = output<void>();
  public readonly handleExpand = output<void>();

  protected onStartClick(): void {
    this.handleStart.emit();
  }

  protected onExpandClick(): void {
    this.handleExpand.emit();
  }
}
